<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="Permissao vertical-flow">
                    <h1 class="title">{{ $t("vinculos-usuarios") }}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{
                                    $t("colaborador")
                                }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    $t("vinculos-usuarios")
                                }}</a>
                            </li>
                        </ul>
                    </nav>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>
                    </div>

                    <div class="Permissao-table registry-wrapper">
                        <b-table
                            :data="allusers"
                            :mobile-cards="false"
                            class="data-table"
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key != 'excluir' ? $t(f.key) : ''
                                "
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'user'">
                                    <router-link
                                        :to="{
                                            name: 'usuario-vinculos-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import GerenciarUsuariosService from "@/services/conta/GerenciarUsuariosService";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("usuario-vinculos") &&
            to.name != "usuario-vinculos"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    data() {
        return {
            allusers: [],
            service: new GerenciarUsuariosService(this.$http, this.$router),
            fields: [{ key: "user", sortable: true }],
            deleteThis: {},
            debouncedOnSearch: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            rotaAninhada: false,
        };
    },
    created() {
        if (
            this.$route.name.includes("usuario-vinculos") &&
            this.$route.name != "usuario-vinculos"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess(
            "admin",
            "colaborador",
            "usuario-vinculos"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "vinculos-usuarios" },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = value.trim();
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (this.$store.state.user.admin) {
                if (currentPage == 1 && this.pagination.currentPage != 1)
                    this.pagination.resetPagination = true;
                this.$store.commit("addLoader");
                this.service
                    .findAll(
                        "usser",
                        "asc",
                        currentPage - 1,
                        this.pagination.perPage,
                        1,
                        this.queryFilter
                    )
                    .then(this.mapItems)
                    .then((value) => {
                        this.allusers = value;
                        this.$store.commit("removeLoader");
                    })
                    .catch((e) => {
                        this.$root.showMessage("error", "msg-erro-load");
                        console.error("Erro ao carregar", e);
                    })
                    .finally((_) => {
                        this.pagination.resetPagination = false;
                    });
            }
        },
        mapItems(body) {
            /*
        @70197 - Foi colocado essa validação para que caso não tenha
        nenhum registro voltado do banco não de o erro na tela e continue
        a aplicação normal.
      */
            if (body.content) {
                this.pagination.totalRows = body.totalElements;
                let Permissaolist = body.content.map((p) => {
                    return {
                        id: p.id,
                        user: p.nome,
                    };
                });
                return Permissaolist;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .Permissao .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .Permissao .search-and-filter .search-bar {
        width: 100%;
    }

    .Permissao .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
